module.exports = __webpack_public_path__ + "static/media/Klara.54267452.png";